import React, { Component } from "react";
import { CardNumberElement, CardExpiryElement, CardCvcElement, injectStripe } from "react-stripe-elements";
import { isLocalhost } from "../../../utils/CommonUtils";

/* eslint-disable*/

const stripeElementStyle = {
    base: {
        fontSize: '16px',
        color: '#333',
        lineHeight: '40px',
        '::placeholder': {
            color: '#aab7c4',
        },
    },
    invalid: {
        color: '#e74c3c',
    },
};

class StripeCheckoutForm extends Component {

    constructor(props) {
        super(props);

        this.state = {
            nameOnCard: isLocalhost ? 't' : '',
            postalCode: isLocalhost ? '07400' : '',
            addressLine1: isLocalhost ? 'Hrushevskoho Street, 23, apartment 84' : '',
            city: '',
        };

        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentDidMount() {
        if (this.props.onRef) {
            this.props.onRef(this);
        }
        // Stripe injects unlabelled <iframe> elements (Link autofill buttons)
        // for Card Number / Expiry / CVC. They have no `title`, which fails
        // WCAG 4.1.2. We can't pass disableLink through react-stripe-elements,
        // so observe the DOM and label them once they appear.
        this._titleStripeIframes = () => {
            const iframes = document.querySelectorAll(
                'div.StripeElement iframe[name^="cardNumberButton"], ' +
                'div.StripeElement iframe[name^="cardExpiryButton"], ' +
                'div.StripeElement iframe[name^="cardCvcButton"]'
            );
            iframes.forEach((f) => {
                if (f.getAttribute('title')) return;
                if (f.name.indexOf('cardNumberButton') === 0) f.setAttribute('title', 'Stripe Link autofill — card number');
                else if (f.name.indexOf('cardExpiryButton') === 0) f.setAttribute('title', 'Stripe Link autofill — expiry date');
                else if (f.name.indexOf('cardCvcButton') === 0) f.setAttribute('title', 'Stripe Link autofill — CVC');
            });
        };
        this._stripeIframeObserver = new MutationObserver(this._titleStripeIframes);
        this._stripeIframeObserver.observe(document.body, { childList: true, subtree: true });
        this._titleStripeIframes();
    }

    componentWillUnmount() {
        if (this.props.onRef) {
            this.props.onRef(null);
        }
        if (this._stripeIframeObserver) {
            this._stripeIframeObserver.disconnect();
            this._stripeIframeObserver = null;
        }
    }

    handleInputChange(e) {
        this.setState({ [e.target.name]: e.target.value });
    }

    async handleSubmit() {
        const nameOnCard = this.state.nameOnCard.trim();
        const postalCode = this.state.postalCode.trim();
        const addressLine1 = this.state.addressLine1.trim();
        const city = this.state.city.trim();
        if (!nameOnCard) {
            return { error: { message: "Please enter the name on your card." } };
        }
        if (!postalCode) {
            return { error: { message: "Please enter your billing postal/ZIP code." } };
        }
        // Billing address fields are forwarded to Stripe to drive AVS checks
        // (`address_postal_code_check`, `address_line1_check`) which improve
        // issuer approval rates for cross-border CNP. None of these are
        // stored in our DB — they live on Stripe's PaymentMethod/Charge only.
        const tokenParams = {
            name: nameOnCard,
            address_zip: postalCode,
        };
        if (addressLine1) tokenParams.address_line1 = addressLine1;
        if (city) tokenParams.address_city = city;
        const result = await this.props.stripe.createToken(tokenParams);
        return result;
    }

    render() {
        const { nameOnCard, postalCode, addressLine1, city } = this.state;
        return (
            <div className="chk_card_fields">
                <div className="chk_form_group">
                    <label className="chk_label">Card Number</label>
                    <div className="chk_input chk_stripe_element">
                        <CardNumberElement style={stripeElementStyle} />
                    </div>
                </div>
                <div className="chk_form_row">
                    <div className="chk_form_group">
                        <label className="chk_label">Expiry Date</label>
                        <div className="chk_input chk_stripe_element">
                            <CardExpiryElement style={stripeElementStyle} />
                        </div>
                    </div>
                    <div className="chk_form_group">
                        <label className="chk_label">CVV</label>
                        <div className="chk_input chk_stripe_element">
                            <CardCvcElement style={stripeElementStyle} />
                        </div>
                    </div>
                </div>
                <div className="chk_form_group">
                    <label className="chk_label">Name on Card</label>
                    <input
                        className="chk_input"
                        type="text"
                        name="nameOnCard"
                        placeholder="John Doe"
                        value={nameOnCard}
                        onChange={this.handleInputChange}
                        autoComplete="cc-name"
                    />
                </div>
                <div className="chk_form_group">
                    <label className="chk_label">Address Line 1 <span className="chk_label_optional">(optional)</span></label>
                    <input
                        className="chk_input"
                        type="text"
                        name="addressLine1"
                        placeholder="123 Main St"
                        value={addressLine1}
                        onChange={this.handleInputChange}
                        autoComplete="address-line1"
                        maxLength={100}
                    />
                </div>
                <div className="chk_form_row">
                    <div className="chk_form_group">
                        <label className="chk_label">City <span className="chk_label_optional">(optional)</span></label>
                        <input
                            className="chk_input"
                            type="text"
                            name="city"
                            placeholder="New York"
                            value={city}
                            onChange={this.handleInputChange}
                            autoComplete="address-level2"
                            maxLength={50}
                        />
                    </div>
                    <div className="chk_form_group">
                        <label className="chk_label">Postal / ZIP Code</label>
                        <input
                            className="chk_input"
                            type="text"
                            name="postalCode"
                            placeholder="10001"
                            value={postalCode}
                            onChange={this.handleInputChange}
                            autoComplete="postal-code"
                            maxLength={12}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default injectStripe(StripeCheckoutForm);



// WEBPACK FOOTER //
// ./src/components/CheckoutComponents/PaymentMethods/StripeCheckoutForm.js